module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "px"
    }
  }), _c('a', {
    attrs: {
      "id": "pxi"
    }
  }), _c('a', {
    attrs: {
      "id": "pxii"
    }
  }), _c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "follow sink"
  }, [_c('em', [_vm._v("Dark.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("Night.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("“He is still asleep, Mother.”")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("“Three drops of the tincture will keep him still.”")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("“Must we leave him?”")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("“We must.”")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("“But he is so young.”")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("“He is old enough. And we cannot keep him with us longer. There is danger to us all if he stays.”")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("“But there is danger for him here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("“That is why we are leaving him high in the tree. The wild dogs cannot climb, nor fox nor wolves. In the daytime he will be quick and bright. He knows his nuts and berries, his mushrooms and ferns. You")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p2"
    }
  }), _c('em', [_vm._v("have taught him well. He will be found soon enough by the wild men of the woods, the wodewose, those without a place, whose villages have heen erased by plague. They will hold him close as we cannot.”")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("“But he is such a little bird, my child, my owlet, my hawkling.”")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("“If you keep him longer")]), _vm._v(", "), _c('em', [_vm._v("be will be your death. And ours. The church forbids it. God’s law. And man’s.”")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("“I would die for him, Mother.”")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("“Let him live for you. Come. Morning will he here soon enough and it is already time for Matins. We dare not miss more than that or there will be talk.”")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("Light.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("Day.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-135a5c6b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front04.vue
// module id = 69
// module chunks = 0